import cookie from "cookie";
import Cookies from "js-cookie";

export const read_limit_cookie_server_side = (req, name, limitDefault = null) => {
	/*
		This function tries to read the limit of a cookie.

		If there is no limit found for the specific cookie name a default limit is returned.
	*/

	const cookies = cookie.parse(req.headers.cookie || "");

	// Return cookie name when cookie declared
	if (cookies[name]) {
		return cookies[name];
	}

	// Return limit_default when declared
	if (limitDefault) {
		return limitDefault;
	}
	// Return default limit when no limit_default declared
	return process.env.NEXT_PUBLIC_TABLE_LIMIT_DEFAULT;
};

/* -------------------------- FILTER COOKIE SECTION ------------------------- */
export const filter_type = Object.freeze({
	BACK_OFFICE_LOG_LIMIT: "back_office_log_limit",
	// BLACKLIST
	BLACKLIST_LIMIT: "blacklist_limit",
	DEBTOR_GROUP_DEBTOR_LIMIT: "debtor_group_debtor_limit",

	// DEBTOR GROUP
	DEBTOR_GROUP_LIMIT: "debtor_group_limit",

	// DEBTOR
	DEBTOR_LIMIT: "debtor_limit",

	// DISCOUNT
	DISCOUNT_LIMIT: "discount_limit",

	// DNS LIMIT
	DNS_LIMIT: "dns_limit",

	// DOMAIN LIMIT
	DOMAIN_LIMIT: "domain_limit",

	// DOMAIN QUEUE
	DOMAIN_QUEUE_LIMIT: "domain_queue_limit",

	// INVOICE
	INVOICE_LIMIT: "invoice_limit",

	// LOGS
	LOG_LIMIT: "log_limit",

	// ORDER
	ORDER_LIMIT: "order_limit",

	// PASSWORD LIMIT
	PASSWORD_LIMIT: "password_limit",
	PRODUCT_GROUP_LIMIT: "product_group_limit",

	// PRODUCT
	PRODUCT_LIMIT: "product_limit",

	// QEMU LIMIT
	QEMU_LIMIT: "qemu_limit",

	// SLA
	SLA_LIMIT: "slal_limit",

	// THEME
	THEME: "theme",

	// TLD LIMIT
	TLD_LIMIT: "tld_limit",

	// USER
	USER_MANAGEMENT_LIMIT: "user_management_limit",
});

export const filter_cookies_get = (filterType) => {
	return Cookies.get(filterType);
};
export const filter_cookies_set = (filterType, value) => {
	Cookies.set(filterType, value, { sameSite: "strict" });
};
export const filter_cookies_unset = (filterType) => {
	Cookies.remove(filterType);
};

export const sign_up_cookies_set = (signUpFormType, value) => {
	Cookies.set(signUpFormType, JSON.stringify(value), { sameSite: "strict" });
};
export const sign_up_cookies_unset = (signUpFormType) => {
	Cookies.remove(signUpFormType);
};

/* ----------------------------- CUSTOM COOKIES ----------------------------- */
export const custom_type = Object.freeze({
	// ACTIVE TAB
	ACTIVE_TAB: "active_tab",
	ACTIVE_TAB_ITEM: "active_tab_item",
	DEBTOR_PRODUCTS_ACTIVE_TAB: "debtor_products_active_tab",
});

export const custom_cookies_get = (customType) => {
	return Cookies.get(customType);
};
export const custom_cookies_set = (customType, value) => {
	Cookies.set(customType, value, { sameSite: "strict" });
};
export const custom_cookies_unset = (customType) => {
	Cookies.remove(customType);
};

/* --------------------------- LOG FILTER COOKIES --------------------------- */
export const log_filter_type = Object.freeze({
	EVENT: "event",
	IP_ADDRESS: "ip_address",
	TAGS: "tags",
	USERNAME: "username",
});

export const log_filter_cookies_get = (logFilterType) => {
	return Cookies.get(logFilterType);
};
export const log_filter_cookies_set = (logFilterType, value) => {
	Cookies.set(logFilterType, value, { sameSite: "strict" });
};
export const log_filter_cookies_unset = (logFilterType) => {
	Cookies.remove(logFilterType);
};
